import React, { Component } from "react";
import $ from "jquery";

import css from "./SisInputText.module.scss";

class SisInputText extends Component {
	constructor(props) {
		super(props);

		this.target = React.createRef();

		this.state = {
			value: props.defaultValue ? props.defaultValue : "",
		};
	}

	changeHandler = (e) => {
		// console.log("change");
		if (this.props.numberOnly) {
			const re = /^[0-9.\b]+$/;

			if (e.target.value === "" || re.test(e.target.value)) {
				this.setState({ value: e.target.value });
			}
		} else {
			this.setState({ value: e.target.value });
		}
	};

	keyPressHandler = (e) => {
		if (this.props.onKeyPress) this.props.onKeyPress(e);
	};

	setValue = (value) => {
		this.setState({
			value,
		});
	};

	clear = () => {
		this.setState({
			value: "",
		});
	};

	render() {
		let { id, name, placeholder, className, defaultValue, style } = this.props;

		return (
			<label>
				<input
					id={id}
					ref={this.target}
					name={name ? name : id}
					className={`${css.sisInputText} ${className}`}
					style={style}
					placeholder={placeholder}
					type="text"
					value={this.state.value}
					onChange={this.changeHandler}
					onKeyPress={this.keyPressHandler}
				/>
			</label>
		);
	}
}

export default SisInputText;
